import axios from 'axios'

export default {
    acceptInvitation(data) {
        return axios.post('/invitation/accept-invitation', data)
    },
}
